const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.vemmackitchen.com/api';

async function request(path) {
  const response = await fetch(`${API_BASE}${path}`);
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }
  return response.json();
}

async function requestWithBody(path, body, { token } = {}) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || `Request failed: ${response.status}`);
  }

  return payload;
}

export function apiUrl(path) {
  return `${API_BASE}${path}`;
}

const mapMenuItem = (row) => ({
  ...row,
  image: row.image || row.image_url || row.image_data_url || null,
  tags: row.tags || [],
  highlight: row.highlight || false,
});

const mapCombo = (row) => ({
  ...row,
  name: row.name || row.title,
  image: row.image || row.image_url || row.image_data_url || null,
  items: row.items || row.meta?.items || [],
  savingsText: row.savingsText || row.savings_text || row.meta?.savingsText,
});

const mapService = (row) => ({
  ...row,
  bulletPoints: row.bulletPoints || row.bullet_points || [],
});

const mapCateringMenu = (row) => ({
  ...row,
  image: row.image || row.image_url || row.image_data_url || null,
  menu: row.menu || row.menu_lines || [],
  features: row.features || [],
});

const mapRentalItem = (row) => ({
  ...row,
  image: row.image || row.image_url || row.image_data_url || null,
});

const mapAddOn = (row) => ({
  ...row,
  id: row.id,
  name: row.name,
  price: Number(row.price) || 0,
  category: row.category || 'protein',
  description: row.description || null,
  image: row.image || row.image_url || row.image_data_url || null,
  available: row.available !== false,
});

export async function fetchMenuItems() {
  const data = await request('/menu-items');
  return data.map(mapMenuItem);
}

export async function fetchCombos() {
  const data = await request('/combos');
  return data.map(mapCombo);
}

export async function fetchServices() {
  const data = await request('/services');
  return data.map(mapService);
}

export async function fetchCateringMenus() {
  const data = await request('/catering-menus');
  return data.map(mapCateringMenu);
}

export async function fetchRentalItems() {
  const data = await request('/rental-items');
  return data.map(mapRentalItem);
}

export async function fetchAddOns() {
  const data = await request('/add-ons');
  return data.map(mapAddOn).filter((item) => item.available !== false);
}

export async function createOrder(payload, options = {}) {
  return requestWithBody('/orders', payload, options);
}

export async function fetchOrderById(orderId) {
  return request(`/orders/${orderId}`);
}

export async function fetchPaymentSettings() {
  return request('/settings/payment');
}

export async function fetchCacheVersions() {
  return request('/cache/versions');
}

export async function createContactMessage(payload) {
  return requestWithBody('/contact-messages', payload);
}

export async function uploadImage(file, folder = 'receipts') {
  if (!file) {
    throw new Error('No file selected for upload.');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);

  const response = await fetch(`${API_BASE}/upload`, {
    method: 'POST',
    body: formData,
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || `Upload failed: ${response.status}`);
  }

  return payload;
}
